import Header from '@/types/purchaseRequest/header'
import { BaseService } from './../../base'
export class HeaderService extends BaseService<Header>() {
    static get entity (): string {
        return 'header'
    }
    static get responseName (): string {
        return 'header'
    }
}